import styles from "./Loader.module.css";

const Loader = () => {
  return (
    <div className={styles.overlay}>
      <div className={styles.scene}>
        <svg
          className={styles.walker}
          viewBox="0 0 200 130"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* ===== Cart ===== */}
          <g className={styles.cart}>
            <path
              className={styles.cartBasket}
              d="M62 60 L108 60 L102 92 L68 92 Z"
              fill="none"
              stroke="#444"
              strokeWidth="3"
              strokeLinejoin="round"
            />
            <line x1="62" y1="60" x2="44" y2="46" stroke="#444" strokeWidth="3" strokeLinecap="round" />
            <line x1="44" y1="46" x2="44" y2="38" stroke="#444" strokeWidth="3" strokeLinecap="round" />
            <circle className={styles.item1} cx="76" cy="72" r="4" fill="#ff6b35" />
            <circle className={styles.item2} cx="86" cy="70" r="4" fill="#ffa26b" />
            <circle className={styles.item3} cx="94" cy="73" r="4" fill="#ffc79a" />
            <circle className={styles.wheelBack} cx="70" cy="98" r="5" fill="#333" />
            <circle className={styles.wheelFront} cx="98" cy="98" r="5" fill="#333" />
          </g>

          {/* ===== Person ===== */}
          <g className={styles.person}>
            <g className={styles.legBack} style={{ transformOrigin: "22px 78px" }}>
              <line x1="22" y1="78" x2="22" y2="98" stroke="#3a3a3a" strokeWidth="6" strokeLinecap="round" />
              <line x1="22" y1="98" x2="30" y2="102" stroke="#3a3a3a" strokeWidth="6" strokeLinecap="round" />
            </g>

            <g className={styles.legFront} style={{ transformOrigin: "22px 78px" }}>
              <line x1="22" y1="78" x2="22" y2="98" stroke="#2b2b2b" strokeWidth="6" strokeLinecap="round" />
              <line x1="22" y1="98" x2="14" y2="102" stroke="#2b2b2b" strokeWidth="6" strokeLinecap="round" />
            </g>

            <path d="M12 78 Q12 50 22 48 Q32 50 32 78 Z" fill="#ff6b35" />

            <g className={styles.armBack} style={{ transformOrigin: "16px 52px" }}>
              <line x1="16" y1="52" x2="10" y2="70" stroke="#ffb98c" strokeWidth="5" strokeLinecap="round" />
            </g>

            <g className={styles.armFront}>
              <line x1="30" y1="52" x2="44" y2="46" stroke="#ffb98c" strokeWidth="5" strokeLinecap="round" />
            </g>

            <circle cx="22" cy="38" r="10" fill="#ffb98c" />
            <path d="M12 34 Q22 22 32 34 Q28 28 22 28 Q16 28 12 34 Z" fill="#3a2a1a" />
          </g>
        </svg>

        <div className={styles.groundLine}></div>
      </div>
    </div>
  );
};

export default Loader;